/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Settings areas that may sit behind the Parental Control PIN.
 */
enum ParentalSettingsArea {
  /** Settings → Parental Controls, including the Hide Adult Content toggle. */
  PARENTAL_CONTROLS = "PARENTAL_CONTROLS",

  /** Profile settings. */
  PROFILE = "PROFILE",

  /** Device settings. */
  DEVICE = "DEVICE",

  /** Remote settings. */
  REMOTE = "REMOTE",

  /** System information. */
  SYSTEM_INFO = "SYSTEM_INFO",

  /** Help. */
  HELP = "HELP"
}

export { ParentalSettingsArea };
